import { db } from '@/data/firebase/config';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Link } from '@/domain/types/collections';
import { useAdminLogger } from '@/domain/use-cases/admin-logger';
import FormAddDocument from '@/presentation/components/form-add-document';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const LinkAddPage = () => {
  const navigate = useNavigate();
  const { logCreate } = useAdminLogger();

  const handleSave = async (data: Link) => {
    try {
      const docRef = await addDoc(collection(db, DOCUMENTS_DB.LINKS), {
        ...data,
        createdAt: serverTimestamp(),
      });

      // Log the action
      await logCreate(DOCUMENTS_DB.LINKS, docRef.id, data.title, data);

      toast.success('Enlace guardado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/links');
    } catch (error) {
      toast.error('Error al guardar el enlace', {
        theme: 'colored',
      });
      // Re-thrown so FormAddDocument knows the save failed and keeps the
      // autosaved draft instead of deleting the user's only remaining copy.
      throw error;
    }
  };

  return (
    <div className="p-4 flex flex-col gap-4 ">
      <h1 className="text-3xl font-bold">Agregar Enlace</h1>
      <FormAddDocument onSave={handleSave} contentType="link" />
    </div>
  );
};

export default LinkAddPage;
